import { cn } from '@change/ds-utils';

type Result = ModelHookResult<{
	containerClasses: string;
	textClasses: string;
}>;

export function useTopImpactStorySummary(isMobile: boolean, isFading: boolean): Result {
	return {
		data: {
			containerClasses: isMobile
				? 'relative flex h-full w-60 items-center justify-center'
				: 'font-weight-light absolute left-1/2 top-full z-20 mt-10 w-60 -translate-x-1/2 transform text-center',
			textClasses: cn(
				'line-clamp-4 overflow-hidden text-ellipsis text-center transition-opacity duration-300',
				isMobile
					? [isFading ? 'opacity-0' : 'opacity-100']
					: 'opacity-0 group-focus-within:opacity-100 group-hover:opacity-100',
			),
		},
	};
}
